import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from '@/shared/utils/requests';
import {createSlice} from '@reduxjs/toolkit';
import {handleAsyncRequest} from '../utils';
import {RECORDS_PER_PAGE} from '@/shared/constants/landingPagesConstants';

const initialState = {
  error: null,
  isLoading: false,
  list: [],
  currentData: [],
};

export const slice = createSlice({
  name: 'landingPages',
  initialState,
  reducers: {
    hasError: (state, action) => {
      state.error = action.payload;
    },
    startLoading: (state) => {
      state.isLoading = true;
    },
    stopLoading: (state) => {
      state.isLoading = false;
    },
    setLandingPagesList: (state, action) => {
      state.list = action.payload;
    },
    setCurrentData: (state, action) => {
      state.currentData = action.payload;
    },
    addLandingPageToList: (state, action) => {
      state.list.push(action.payload);
    },
    updateLandingPage: (state, action) => {
      const foundIndex = state.list.findIndex(
        ({id}) => id === action.payload.id
      );

      if (foundIndex === -1) return;

      state.list[foundIndex] = {
        ...state.list[foundIndex],
        ...action.payload,
      };
    },
    deleteLandingPage(state, action) {
      state.list = state.list?.filter(({id}) => id !== action.payload);
    },
  },
});

export default slice.reducer;
const actions = slice.actions;

// Export actions
export const {
  hasError,
  startLoading,
  stopLoading,
  setLandingPagesList,
  setCurrentData,
  addLandingPageToList,
} = actions;

// Selectors
export const getAllLandingPages = (state) => state.landingPages.list;

export const getLandingPageById =
  ({landingPageId}) =>
  (state) =>
    state.landingPages.list.find(({id}) => {
      return id === landingPageId;
    });

// Fetch LandingPages
export const fetchLandingPages = () => async (dispatch) => {
  const {error, body} = await handleAsyncRequest({
    dispatch,
    actions,
    requestFn: getRequest,
    endpoint: '/landing-pages',
    toastMessage: {success: {show: false}, error: {show: true}},
  });

  if (error) throw error;

  dispatch(actions.setLandingPagesList(body?.landingPages ?? []));

  const initialData = body?.landingPages?.slice(0, RECORDS_PER_PAGE) ?? [];
  dispatch(actions.setCurrentData(initialData));
};

// Create Landing Page
export const createNewLandingPage = (data) => async (dispatch) => {
  const {error, body} = await handleAsyncRequest({
    dispatch,
    actions,
    requestFn: postRequest,
    endpoint: '/landing-pages',
    payload: data,
    toastMessage: {success: {show: true}, error: {show: true}},
  });

  if (error) throw error;
  else {
    dispatch(actions.addLandingPageToList(body?.landingPage));
    return body?.landingPage;
  }
};

export const updateLandingPage = (data) => async (dispatch) => {
  const {error, body} = await handleAsyncRequest({
    dispatch,
    actions,
    requestFn: patchRequest,
    endpoint: `/landing-pages/${data?.id}`,
    payload: data,
    toastMessage: {success: {show: true}, error: {show: true}},
  });

  if (error) throw error;
  else {
    dispatch(actions.updateLandingPage(body?.landingPage));
    return body?.landingPage;
  }
};

// Delete LandingPage
export const deleteLandingPage = (data) => async (dispatch) => {
  const {error} = await handleAsyncRequest({
    dispatch,
    actions,
    requestFn: deleteRequest,
    endpoint: `/landing-pages/${data?.id}`,
    payload: data,
    toastMessage: {success: {show: true}, error: {show: true}},
  });

  if (error) throw error;
  else dispatch(actions.deleteLandingPage(data?.id));
};

export const duplicateLandingPage = (data) => async (dispatch) => {
  const {error, body} = await handleAsyncRequest({
    dispatch,
    actions,
    requestFn: postRequest,
    endpoint: `/landing-pages/${data?.id}/duplicate`,
    payload: data,
    toastMessage: {success: {show: true}, error: {show: true}},
  });

  if (error) throw error;
  dispatch(actions.addLandingPageToList(body?.landingPage));
  return body?.landingPage;
};
